<template>
  <b-form-group>
    <div class="flex justify-between">
      <label v-text="label" />

      <div class="flex items-center gap-[12px]">
        <svg
          v-if="showLinked"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="cursor-pointer"
          @click="linked = !linked"
        >
          <path
            d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346624 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9972 5.87913 15.1534 3.84593 13.6538 2.34624C12.1541 0.84656 10.1209 0.00280458 8 0ZM9.06 10.47L8.35 11.18C8.12024 11.413 7.84614 11.5977 7.54386 11.7231C7.24158 11.8484 6.91725 11.912 6.59 11.91C6.09613 11.9108 5.61312 11.765 5.20211 11.4912C4.7911 11.2173 4.47056 10.8277 4.28107 10.3716C4.09157 9.91556 4.04163 9.41351 4.13756 8.92904C4.2335 8.44457 4.471 7.99944 4.82 7.65L5.53 6.94C5.57514 6.8926 5.62944 6.85486 5.68961 6.82907C5.74977 6.80328 5.81455 6.78999 5.88 6.78999C5.94546 6.78999 6.01024 6.80328 6.0704 6.82907C6.13057 6.85486 6.18486 6.8926 6.23 6.94C6.27747 6.98614 6.3152 7.04133 6.34096 7.10231C6.36672 7.16328 6.38 7.22881 6.38 7.295C6.38 7.36119 6.36672 7.42672 6.34096 7.48769C6.3152 7.54867 6.27747 7.60386 6.23 7.65L5.52 8.35C5.24287 8.63305 5.08839 9.01387 5.09 9.41C5.08733 9.60644 5.124 9.80142 5.19785 9.98347C5.2717 10.1655 5.38124 10.3309 5.52 10.47C5.65964 10.6102 5.82561 10.7215 6.00837 10.7975C6.19113 10.8734 6.38709 10.9125 6.585 10.9125C6.78291 10.9125 6.97887 10.8734 7.16164 10.7975C7.3444 10.7215 7.51036 10.6102 7.65 10.47L8.35 9.77C8.39614 9.72254 8.45134 9.68481 8.51231 9.65904C8.57329 9.63328 8.63881 9.62001 8.705 9.62001C8.7712 9.62001 8.83672 9.63328 8.8977 9.65904C8.95867 9.68481 9.01386 9.72254 9.06 9.77C9.10741 9.81514 9.14515 9.86944 9.17093 9.9296C9.19672 9.98977 9.21002 10.0545 9.21002 10.12C9.21002 10.1855 9.19672 10.2502 9.17093 10.3104C9.14515 10.3706 9.10741 10.4249 9.06 10.47ZM9.41 7.29L7.29 9.41C7.24486 9.4574 7.19057 9.49514 7.1304 9.52093C7.07024 9.54672 7.00546 9.56001 6.94 9.56001C6.87455 9.56001 6.80977 9.54672 6.74961 9.52093C6.68944 9.49514 6.63514 9.4574 6.59 9.41C6.5426 9.36486 6.50486 9.31056 6.47907 9.2504C6.45329 9.19023 6.43999 9.12546 6.43999 9.06C6.43999 8.99454 6.45329 8.92977 6.47907 8.8696C6.50486 8.80944 6.5426 8.75514 6.59 8.71L8.71 6.59C8.7558 6.54327 8.8104 6.50609 8.87065 6.48059C8.93091 6.4551 8.99562 6.4418 9.06104 6.44147C9.12646 6.44114 9.1913 6.45378 9.25181 6.47867C9.31232 6.50355 9.3673 6.54018 9.41356 6.58645C9.45982 6.63271 9.49645 6.68768 9.52134 6.74819C9.54622 6.8087 9.55886 6.87354 9.55853 6.93896C9.5582 7.00439 9.54491 7.0691 9.51941 7.12935C9.49392 7.18961 9.45673 7.24421 9.41 7.29ZM11.18 8.35L10.47 9.06C10.4254 9.10808 10.3712 9.14627 10.3109 9.17211C10.2506 9.19795 10.1856 9.21086 10.12 9.21C10.0546 9.20989 9.98982 9.19655 9.92967 9.17077C9.86952 9.14499 9.81521 9.10731 9.77 9.06C9.72254 9.01386 9.68481 8.95867 9.65905 8.89769C9.63329 8.83672 9.62001 8.7712 9.62001 8.705C9.62001 8.63881 9.63329 8.57328 9.65905 8.51231C9.68481 8.45133 9.72254 8.39614 9.77 8.35L10.48 7.65C10.7571 7.36695 10.9116 6.98613 10.91 6.59C10.9127 6.39356 10.876 6.19858 10.8022 6.01653C10.7283 5.83449 10.6188 5.66906 10.48 5.53C10.3404 5.38976 10.1744 5.27847 9.99164 5.20254C9.80887 5.12661 9.61291 5.08752 9.415 5.08752C9.21709 5.08752 9.02113 5.12661 8.83837 5.20254C8.65561 5.27847 8.48965 5.38976 8.35 5.53L7.65 6.23C7.60386 6.27746 7.54867 6.31519 7.4877 6.34096C7.42672 6.36672 7.3612 6.37999 7.295 6.37999C7.22881 6.37999 7.16329 6.36672 7.10231 6.34096C7.04134 6.31519 6.98614 6.27746 6.94 6.23C6.8926 6.18486 6.85486 6.13056 6.82907 6.0704C6.80329 6.01023 6.78999 5.94546 6.78999 5.88C6.78999 5.81454 6.80329 5.74977 6.82907 5.6896C6.85486 5.62944 6.8926 5.57514 6.94 5.53L7.65 4.82C8.11863 4.35439 8.75272 4.09354 9.41333 4.09461C10.0739 4.09568 10.7072 4.35858 11.1743 4.8257C11.6414 5.29282 11.9043 5.92607 11.9054 6.58667C11.9065 7.24728 11.6456 7.88137 11.18 8.35Z"
            :fill="linked ? '#7CACFA' : '#B8B8B8'"
          />
        </svg>

        <!--        <svg-->
        <!--          v-b-tooltip.hover-->
        <!--          width="13"-->
        <!--          height="11"-->
        <!--          viewBox="0 0 13 11"-->
        <!--          fill="none"-->
        <!--          xmlns="http://www.w3.org/2000/svg"-->
        <!--          class="cursor-pointer hover:opacity-80"-->
        <!--          title="Sync for all devices"-->
        <!--        >-->
        <!--          <path-->
        <!--            d="M12.448 4.05812C12.2986 4.05812 12.1507 4.12483 12.0532 4.25228L11.8366 4.53357C11.5125 2.61083 10.1658 0.965895 8.25398 0.302245C7.66551 0.0981219 7.0616 4.29053e-05 6.46566 4.29053e-05C4.68132 4.29053e-05 2.9642 0.880263 1.93611 2.43011C1.78426 2.65912 1.847 2.9683 2.07601 3.12014C2.30602 3.27299 2.6137 3.20926 2.76655 2.98024C3.88624 1.2905 6.00862 0.575571 7.92689 1.24271C9.51855 1.79533 10.6288 3.18088 10.8658 4.78997L10.4396 4.46188C10.221 4.2951 9.90887 4.33493 9.74159 4.55299C9.57381 4.77105 9.61414 5.08321 9.8322 5.25099C9.8322 5.25099 11.0096 6.1576 11.0126 6.15959C11.2601 6.35027 11.6121 6.45731 11.8361 6.16507L12.8418 4.85918C13.0096 4.64111 12.9692 4.32895 12.7512 4.16117C12.6611 4.09197 12.554 4.05812 12.448 4.05812V4.05812Z"-->
        <!--            fill="#717171"-->
        <!--          />-->
        <!--          <path-->
        <!--            d="M10.87 7.76965C10.6415 7.6178 10.3323 7.68053 10.1795 7.90955C9.05978 9.59879 6.9354 10.3137 5.01913 9.64709C3.42747 9.09446 2.31723 7.70891 2.08025 6.09982L2.50642 6.42791C2.72498 6.59519 3.03714 6.55536 3.20442 6.3368C3.3722 6.11874 3.33188 5.80658 3.11381 5.6388C3.11381 5.6388 1.93637 4.73269 1.93338 4.7302C1.68146 4.53653 1.33744 4.428 1.10992 4.72472L0.104239 6.03062C-0.063541 6.24868 -0.0232145 6.56084 0.194849 6.72862C0.412913 6.8964 0.72557 6.85557 0.892852 6.63751L1.10942 6.35622C1.43353 8.27896 2.78025 9.9239 4.69204 10.5875C7.04194 11.403 9.63879 10.5283 11.0099 8.46018C11.1618 8.23067 11.099 7.92199 10.87 7.76965Z"-->
        <!--            fill="#717171"-->
        <!--          />-->
        <!--        </svg>-->

        <svg
          v-b-tooltip.hover
          width="9"
          height="9"
          viewBox="0 0 9 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="cursor-pointer hover:opacity-80"
          title="Remove for all"
          @click="removeAll"
        >
          <path
            d="M5.49124 4.49994L8.85622 1.1346C8.94878 1.04196 8.99985 0.918365 9 0.786575C9 0.654713 8.94893 0.530973 8.85622 0.43848L8.56134 0.143656C8.46863 0.0507959 8.34505 -6.10352e-05 8.21312 -6.10352e-05C8.08141 -6.10352e-05 7.95783 0.0507959 7.86512 0.143656L4.50015 3.50878L1.13502 0.143656C1.04246 0.0507959 0.918805 -6.10352e-05 0.786951 -6.10352e-05C0.655244 -6.10352e-05 0.531585 0.0507959 0.439024 0.143656L0.144 0.43848C-0.048 0.630492 -0.048 0.942805 0.144 1.1346L3.50905 4.49994L0.144 7.86513C0.0513659 7.95792 0.000365854 8.08151 0.000365854 8.2133C0.000365854 8.34509 0.0513659 8.46869 0.144 8.5614L0.438951 8.85622C0.531512 8.94901 0.655244 8.99994 0.786878 8.99994C0.918732 8.99994 1.04239 8.94901 1.13495 8.85622L4.50007 5.49103L7.86505 8.85622C7.95776 8.94901 8.08134 8.99994 8.21305 8.99994H8.21319C8.34498 8.99994 8.46856 8.94901 8.56127 8.85622L8.85615 8.5614C8.94871 8.46876 8.99978 8.34509 8.99978 8.2133C8.99978 8.08151 8.94871 7.95792 8.85615 7.86521L5.49124 4.49994Z"
            fill="#717171"
          />
        </svg>
      </div>
    </div>

    <div class="flex items-start flex-nowrap">
      <b-input-group class="flex-nowrap">
        <div
          v-for="(angle, index) in angles"
          :key="angle.value"
          class="w-100 ml-[-1px]"
        >
          <sid-input
            :ref="angle.value"
            :sid="sid"
            :var="angle.cssVar"
            :label="angle.text"
            :presudo="presudo"
            :rule-name="`${ruleName}-${angle.value}`"
            class="!w-[61px]"
            :min="min"
            @change="onChange"
          />
          <span
            v-if="!angle.text"
            class="text-[8px] font-[700] text-uppercase pl-[4px] text-nowrap"
            v-text="titles[index]"
          />
        </div>
      </b-input-group>
    </div>
  </b-form-group>
</template>

<script>
import SidConcept from '@/components/mixins/SidConcept'
import SidInput from '@/components/editor/components/sid-controls/SidInput'

export default {
  name: 'SidLinkedGroup',
  components: {SidInput},
  mixins: [SidConcept],
  props: {
    label: {
      type: String
    },
    angles: {
      type: Array,
      default: () => [
        {
          text: 'Top',
          value: 'top'
        },
        {
          text: 'Right',
          value: 'right'
        },
        {
          text: 'Bottom',
          value: 'bottom'
        },
        {
          text: 'Left',
          value: 'left'
        }
      ]
    },
    titles: {
      type: Array,
      default: () => ['top', 'right', 'bottom', 'left']
    },
    min: {
      type: Number,
      default: -100
    },
    showLinked: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      linked: false
    }
  },
  methods: {
    removeAll () {
      this.$emit('changed')
      this.angles.forEach(angle => {
        this.$refs[angle.value][0].val = 0
      })
    },
    onChange (val) {
      this.$emit('change')
      if (!this.linked) return
      this.angles.forEach(angle => {
        this.$refs[angle.value][0].val = isNaN(val) ? 0 : val
      })
      this.$emit('changed')
    }
  }
}
</script>

<style lang="scss">
.input-group {
  & > div:first-child input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  & > div:last-child input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  & > div:nth-child(2) input,
  & > div:nth-child(3) input {
    border-radius: 0;
  }
}
</style>